var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _ellipse3, _ellipse4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path19, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse5, _ellipse6, _path39, _ellipse7, _ellipse8, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse9, _ellipse10, _path67, _ellipse11, _ellipse12, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _ellipse13, _ellipse14, _path92, _ellipse15, _ellipse16, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _ellipse17, _ellipse18, _path126, _path127, _ellipse19, _ellipse20, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriendsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#adbec4}.st2{fill:#3d70b2}.st3{fill:#ef6e4b}.st4{fill:#ff8b66}.st5{fill:#cfd8dc}.st6{fill:#db614d}.st7{fill:#1a4850}.st8{fill:#fff}.st9{fill:#164353}.st10{fill:#205260}.st11{fill:#0c476b}.st12{fill:#105e99}.st13{fill:#5ee5d1}.st14{fill:#3accb6}.st15{fill:#41d6c3}.st17{fill:#31bca4}.st18{fill:#225866}.st19{fill:#8bbddb}.st20{fill:#6097b2}.st21{fill:#3e6575}.st23{fill:#13bc9c}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.8 411.3H55.7c-1 0-1.8-.8-1.8-1.8v-1c0-1 .8-1.8 1.8-1.8h55.1c1 0 1.8.8 1.8 1.8v1c-.1 1-.8 1.8-1.8 1.8zm349.1 0h-15.1c-1 0-1.8-.8-1.8-1.8v-1c0-1 .8-1.8 1.8-1.8h15.1c1 0 1.8.8 1.8 1.8v1c0 1-.8 1.8-1.8 1.8zm-245.4 0h-55.1c-1 0-1.8-.8-1.8-1.8v-1c0-1 .8-1.8 1.8-1.8h55.1c1 0 1.8.8 1.8 1.8v1c-.1 1-.8 1.8-1.8 1.8zm80.9 0h-55.1c-1 0-1.8-.8-1.8-1.8v-1c0-1 .8-1.8 1.8-1.8h55.1c1 0 1.8.8 1.8 1.8v1c-.1 1-.8 1.8-1.8 1.8zm99.1 0h-75.1c-1 0-1.8-.8-1.8-1.8v-1c0-1 .8-1.8 1.8-1.8h75.1c1 0 1.8.8 1.8 1.8v1c-.1 1-.9 1.8-1.8 1.8z",
    opacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.3 161.1s-5.8-4-14.3-.9c-8.5 3-10.4 14.5-8.3 23.8s-9.6 41.1-9.6 41.1 6.1 8.6 27.4 5.3c0 0 15.9-28.8 14.7-49.6s-9.9-19.7-9.9-19.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136 196.8c8-2.6 12.9 4.1 17.5 16.5s6.1 13.6 6.1 13.6l17.7 11.4-1.5 6.6s-16.8-6.6-20.9-10.8c-4.1-4.2-15.8-25.4-15.8-25.4l-3.1-11.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97 276.9s-3.5 17.6-2.9 44c0 0-13.7 20.2-2.4 77.7h5.9s4.8-49 8.5-62.2c3.7-13.3 17.4-17.3 18.1-57.7L97 276.9zm-27.1 51.7c-3.4-11.3-12.3-30.3-35-56.1 0 0-1.4-.7-3.2.4-1.9 1.2-1.9 2.6-1.9 2.6s11.4 24.8 18.6 43c2.4 6.1 8.3 10.1 14.9 10.1h6.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.2 350.6s.1 8.5-5.5 8.6c-7.8.2-8.1-8.3-17-8s-27.2 2.5-33-11.4c-3-7.2 1.1-16.4-8.6-23.3s-5-14.7 0-18.9c5-4.2-2.2-8.7 3.1-10.8 1.2-.5 2.5-.4 3.6-.1.7.2 1.3.6 1.9 1 2.8 1.8 4.7 5 4.7 5C75 252.3 101.2 247 101.2 247l25.9 8.9c.7 62.7-15.9 94.7-15.9 94.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136 196.8s-6 2-14.6.7-11.4-6.7-17.4-3.2c-9.1 5.2-4.8 23.2-2.5 32.5.8 3.5 1.9 12.6-.1 20.2 0 0 12.1 9.4 25.9 8.9l7.5-16.4c-.1 0 16.3-19.6 1.2-42.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.6 181.8s1 8.5-2.1 16.2c0 0 4.5 6.6 8.8 2.3 0 0 .4-7.8 5.2-16.6 3.2-5.9-11.9-1.9-11.9-1.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.8 182.1s-3.8-2.4-3.4 1.3c.5 4.3 4.7 5.1 5.1 3.6.5-1.5-1.7-4.9-1.7-4.9zm21.7-4.7s2.4-3.8 3.6-.3c1.4 4.1-2 6.6-3.1 5.5-1.1-1.1-.5-5.2-.5-5.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.6 194.9c-6.9 1.5-11.7-2.1-14.7-15.5-1.6-6.9 1-12 8.7-13.7s11.9 1.8 13.4 8.7c3.3 14.4-.3 18.9-7.4 20.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-22.512 132.298 180.297)",
    className: "st6",
    cx: 132.3,
    cy: 180.3,
    rx: 1.6,
    ry: 1.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-8.885 118.23 183.487)",
    className: "st6",
    cx: 118.2,
    cy: 183.5,
    rx: 1.6,
    ry: 1.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.1 173.4c-.1 0-.1 0-.2-.1-1.2-.8-2.8-.4-2.9-.4-.2.1-.4-.1-.4-.3s.1-.4.3-.4c.1 0 2-.5 3.4.5.2.1.2.3.1.5s-.2.2-.3.2zm-13 2.9c-.1 0-.1 0-.2-.1-.2-.1-.2-.3-.1-.5.9-1.5 2.8-1.9 2.9-1.9.2 0 .4.1.4.3s-.1.4-.3.4c0 0-1.7.3-2.4 1.5 0 .3-.1.3-.3.3z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-12.621 128.5 177.4)",
    className: "st7",
    cx: 128.5,
    cy: 177.4,
    rx: 0.9,
    ry: 1.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-12.621 119.002 179.399)",
    className: "st7",
    cx: 119,
    cy: 179.4,
    rx: 0.9,
    ry: 1.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M122.9 187.3s4.4-.4 6.3-2c0 0-.5 3.4-2.9 3.7-2.4.2-3.4-1.7-3.4-1.7zm4.1-10s.2-2.2 1-2.3c.9 0 1.9 1.6 1.9 1.6l1.1-.9-1.2.4s-1.1-1.7-1.9-1.6c-1.2.4-.9 2.8-.9 2.8zm-6.6 1.7s-1.1-2-1.9-1.6c-.8.3-1 2.3-1 2.3l-1.4-.4 1.3-.1s.2-2 1-2.2c1.1-.3 2 2 2 2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M125.1 183.3l-.4-.7c.6-.3.6-.7.6-1-.1-.4-.4-.7-.7-.7-.1 0-.3.1-.3.4l-.7-.3c.3-.8.9-.9 1.1-.8.6 0 1.2.6 1.3 1.3.2.8-.1 1.4-.9 1.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.3 184.5s-2.1-7.8-.9-13.3c0 0 6-8.3 17.5-4.2 0 0 3.4 5.5 5.1 13.2 0 0 .4-2.8-.7-8.9-1.1-6.2-6.6-10-14.1-8.8-7.5 1.3-15.5 8.7-6.9 22z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.4 165.3s.5 2-1.5 7.3c0 0-1.4-1.5-3.1 0s-5 1-6.2 1.8-1.2 2.6-1.2 2.6-1-2.3 0-5c0 0-2.2 2.9-1.9 6.4 0 0-3-.5-2.9-5.5s7.3-13.2 15.3-12.6c8 .5 9.9 13.2 9.9 13.2s-.7-.6-1.9-.3c0 0-.2-2.7-2-6.1 0 0 .8 2.4 0 5.1 0 0-2.2-1.2-4-.8 0-.1 1.1-2.2-.5-6.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9 196c3.9-3.1 6.9.8 7.7 6.2.7 5.4-6.3 37.3-11.8 36.2-2.1-.5-3-8.8-3-8.8s2.1-9 3.5-22.5c.7-6.3 1.5-9.5 3.6-11.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.5 233.8c-5.3-5-14.7-21.6-17.1-30.1l4-1.6s12 17.2 17.5 21.5 7.4 9.2 5 13.3c-2.5 4.2-8.3-2-9.4-3.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.1 192.7c-.3 5.4 4.2 6.7 2.2 10.9-.4.9-1 1.3-1.7 1.5-1.2.4-2.6 0-3.5-.9-2.1-2.1-5.4-4.4-7.1-5.4-2-1.1-.9-1.4-.9-1.4-.2-.1-.4-.2-.6-.2-1.4-.6-2.5-.8-1.5-1.4 1.1-.7 5.2.8 5.2.8-5.3-3.5-6.7-2.7-5.8-3.4 1.3-1 6.3 1.3 6.5 1.4-2.8-2.6-4.8-3.2-3.7-3.6 1.1-.4 6.7 3.6 8.7 5.1.5.3.7.6.7.6.1-4.6 1.5-4 1.5-4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73 196c.5.3.7.6.7.6s-.9 1.6.3 3.7c0-.1-2.2-1.6-1-4.3zm-4.6 3.1c-.5-.3-3.1-1.8-4.2-1.7-.2-.1-.4-.2-.6-.2.8-1 4.3 1.5 4.8 1.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 88.3,
    cy: 279.7,
    r: 1.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 107.3,
    cy: 287,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 123.6,
    cy: 291,
    r: 1.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 98.6,
    cy: 265.7,
    r: 1.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 102.2,
    cy: 275.9,
    r: 1.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 119.1,
    cy: 281.7,
    r: 1.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 121.4,
    cy: 264.2,
    r: 1.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 110.4,
    cy: 260.5,
    r: 1.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 78.9,
    cy: 300.5,
    r: 1.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 63.6,
    cy: 295.9,
    r: 1.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.6 287.6c-.2.3-.5.5-.9.5-.6 0-1.1-.5-1.1-1.1 0-.1 0-.3.1-.4.7.3 1.3.6 1.9 1z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 84.3,
    cy: 314.4,
    r: 1.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 57,
    cy: 329.5,
    r: 1.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 68.2,
    cy: 320.4,
    r: 1.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 51.5,
    cy: 312.3,
    r: 1.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 65,
    cy: 344.2,
    r: 1.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 75.1,
    cy: 288.1,
    r: 1.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 85.4,
    cy: 270.1,
    r: 1.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 97,
    cy: 255.1,
    r: 1.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 73.5,
    cy: 276.9,
    r: 1.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 86.4,
    cy: 259.5,
    r: 1.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 66,
    cy: 307.5,
    r: 1.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 52.6,
    cy: 298.1,
    r: 1.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 91.5,
    cy: 294.9,
    r: 1.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 113.6,
    cy: 300.5,
    r: 1.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 112.5,
    cy: 270.1,
    r: 1.1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 125.3,
    cy: 272.3,
    r: 1.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 99.7,
    cy: 308.6,
    r: 1.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 90.4,
    cy: 327.6,
    r: 1.1
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 74,
    cy: 330.6,
    r: 1.1
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 119.1,
    cy: 314.4,
    r: 1.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 104.4,
    cy: 322.5,
    r: 1.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 82.2,
    cy: 346.3,
    r: 1.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 98.6,
    cy: 340.8,
    r: 1.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 114.5,
    cy: 334.5,
    r: 1.1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 107.3,
    cy: 352.8,
    r: 1.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M107.2 409.1H89.7c-1.1-3.3 1-6.5.6-9.4-.6-4.9 2.2-2.2 2.2-2.2.5-5.2 7.8-6.2 7.8-3.9-.1 3.4.5 5.6 1.5 7 2 2.9 5.2 2.8 5.8 4.9.1.2.1.4.1.6.6 2.5-.5 3-.5 3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M107.7 406c-3.6.8-12-.3-12.3-2.4-.3-2 4.2-3 6.4-3.1 2 2.9 5.2 2.8 5.8 4.9.1.2.1.4.1.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M35.2 273.3c-1.9-1.7-4.9 1.1-4.9 1.1s1.6 2.4.6 3.4c-1.1 1-2.3-1.3-4.4-.3-.2.1-.3.2-.5.3-1.6 1-3.3 3-4.7 4.5-.3.3-.5.6-.8.9-1.6 1.7-5.7 2.6-6.5-1.8s4.2-9.6 9.7-14.4 9-1.9 9-1.9 1.2 2 1.2 3.3c0 1.2 1.1 1.9 1.7 3.1.8 1-.4 1.8-.4 1.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M26 277.8c-1.6 1-3.3 3-4.7 4.5-2.1.5-3.9.3-4.2-1.6-.7-4.7 8.6-10.6 7.9-7.3-.4 1.7.3 3.2 1 4.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M350.6 401.5c-.9-.5-1.7-1.5-2.4-2.7 0 0-.6-3.7 0-7.7.6-3.9-1.1-7.1-6.6-8.3-5.4-1.2-8.6 1.4-7.4 12.3-.8 4.5-1 9.7.9 14h16.6s2.7-5.7-1.1-7.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.2 343s0 10.8-6.1 21.9c-6.2 11.3-13.9 26.8-13.9 26.8s-5.1 5-8.4-3.3c0 0 2.3-28.8 7.6-39.4 5.3-10.4 20.8-6 20.8-6zm79.7-35.3s9.9 41.6 16.2 52.6c0 0-1.4 4.6-8.3 6 0 0-21.5-31.6-22.9-45-1.4-13.3 15-13.6 15-13.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.6 317.5c-2.6 6.3-23 6.7-23 6.7l-1.6-2.3-.4-.6-3.2-4.7s-33.7-33-40.2-30.3l-.6.3c-4.5 3.2-4.9 20.9-10.3 50.5-.5 2.8-1.6 6.1-2.5 8.3-.1.2-.2.5-.3.7-.5 1.3-.8 2.1-.8 2.1-20.6 8.3-27.3-8.1-27.3-8.1s.2-.5.6-1.2l.3-.6c1.1-2.4 2.8-6.5 2.8-8.7 0-2.4 0-4.7-.1-6.9V303c0-2.3.1-4.5.1-6.6v-.6c.2-9.4.5-15.6.8-19.8v-.6c.6-7 1.2-7.7 1.2-7.7l-4.1-28.6h45s6.8 6.8 15.5 15.7l.5.5c3.2 3.2 6.6 6.7 10 10.3l.4.4c1.4 1.4 2.7 2.8 4.1 4.2l.5.5c4.5 4.7 8.9 9.3 12.6 13.3l.4.4c5.1 5.5 9 10 10.4 12 3.6 5.5 6.3 12.5 7.9 16.9.1.2.1.4.2.6.7 2.3 1.1 3.6 1.1 3.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M351.9 272.1c-1.8 2.2-4.5 3.5-7.9 4v-.6c3.2-.5 5.8-1.7 7.5-3.8 3.1-3.6 2.6-8.6 2.6-8.6l.6-.1c0 .2.5 5.2-2.8 9.1zm50.2-16.7h-.5c-5 0-10.2-5.5-10.5-5.7l.4-.4c.1.1 5.3 5.5 10.1 5.6l.5.5zM368 345.5c-.1.2-.2.5-.3.7-3.3 1.2-6.4 1.7-9.2 1.7-8.9 0-15-5.1-18.4-9l.3-.6c4.3 5.1 13.5 12.6 27.6 7.2zm12-69.4c.7 3.2 1.2 6.7 1.2 10.3l-.6.3c0-16.8-9.7-29.8-9.8-30l.4-.3c.1.1 5.8 7.9 8.6 19.1 1.1-.7 1.9-1.8 2.2-3.2 1.4-5.9-5-15.5-5-15.6l.5-.3c.3.4 6.6 9.9 5.1 16-.3 1.6-1.2 2.8-2.6 3.7zm50.1 8.4c-1.7 1.8-3.2 3.3-3.4 3.5l-.3.3-.1-.4c-2.2-5.7-16.2-18-16.3-18.2l-.2-.2 2.3-3.9.4.4-2 3.2c2.7.9 4.7 1.1 6 .9l.5.5c-.5.1-.9.1-1.5.1-1.3 0-2.7-.3-4.3-.7 3.2 2.9 13 12 15.3 17.1.9-.9 2-2 3.1-3.2.2.3.4.5.5.6zm-76.8 38.2h-.2c-.2.1-2.7.6-5.6.6-1.5 0-3-.1-4.4-.5v-.6c3.7 1.1 8.6.2 9.7 0l-.9-23.1c-.5 1.3-1.6 3-3.5 4-.9.5-2 .7-3.1.7-.7 0-1.4-.1-2.1-.2v-.6c1.9.4 3.6.3 5-.4 2.4-1.2 3.3-3.7 3.6-4.7-1.9.3-5.6-.7-8.4-1.5v-.6c3.1.9 7.2 2 8.7 1.5l.4-.1.8 25.5zm95.2-8.7c-3.2 3.2-9.8 8.1-20 8.1-1.1 0-2.2-.1-3.4-.2l-.4-.6c12.4 1.4 20.1-4.4 23.6-7.8.1.2.2.4.2.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M394.3 117.4s-1.2-2.8-6.5-2.8c-4 0-5.6 2.2-5.6 2.2-2.4 7-5 34-5.9 34.9-.5.5-30.3 20.6-30.3 20.6 16.2.3 26.3 20.3 26.3 20.3.5-6.6 18.8-32.5 19-34.9.5-4.4 8.2-23.9 3-40.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M342.6 258.2s-.1 5.6 1.7 6c1.8.4 16.6 4.7 33.6-3s20-13.5 15-17.7c-5-4.3-50.3 14.7-50.3 14.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M335.7 176.2s-15.5-1.8-24.4 2c0 0-2.5 11 9.7 35.6s9.4 40.1 23.1 45.9c12.2 5.2 48.2-10.2 49.3-15.3 2.8-12.8-19.2-35.4-20.5-48.5-1.3-13.1-14.1-32.7-37.2-19.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M311.4 178.2c-10.8 3.8-23 16-23 21.9s10.2 8.1 10.2 8.1l16.7-8.1s4.8-3.3 1.7-13c-3.1-9.8-5.6-8.9-5.6-8.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.8 189c-3.2 0-7.2-1.2-9.7-2.9-1.4-1-2.2-2.1-2.4-3.2-.6-3.8 3.1-5.8 3.3-5.9l.5 1c-.1.1-3.2 1.7-2.7 4.7.1.8.8 1.7 1.9 2.5 2.8 2 7.6 3.2 10.8 2.6 1.4-.2 2.3-.8 2.8-1.5.5-.9.1-2 .1-2l1-.4c0 .1.6 1.5-.1 2.9-.6 1.1-1.8 1.8-3.5 2.1-.7 0-1.3.1-2 .1zm-13.7 11.7c-2.4 0-6.4-1-6.9-4.9-.3-2-.1-3.7.1-5.1.2-2.2.4-3.9-.8-5.9-2.1-3.4-4.9-3.6-5-3.6l.1-1.1c.1 0 3.5.2 5.9 4.1 1.5 2.4 1.2 4.4 1 6.6-.2 1.5-.3 3-.1 4.9.6 4.2 6 4 6.2 4l.1 1.1c-.3-.1-.4-.1-.6-.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M345.5 180.8s8.2-5.6 6.2-11.6c-1.9-6-28.3-5.6-35.1 1.6-6.8 7.2 14.7 12 14.7 12 1.7-3.4 12.3-3.8 14.2-2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M330.8 179.8c-3.9-1.3-6.2-4.1-5.4-7.4.8-3.2 17.5-3.3 20.7-.7 3.2 2.6-1.3 12.9-15.3 8.1z",
    fill: "#24a088"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.9 170.7s3.4 5.9 1.8 9.1c0 0 11.8 4.1 11.8-2.5 0 0-2.2-4.9-1.4-8.1l-12.2 1.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325 165.6s-5.8-9.3-5.3-18.1c.3-4.4 2.5-6.2 2.5-6.2s-1.8-2.6.1-6.5c0 0 2.7 3.2 12.3 2.2 9.2-1 10.2 5.6 10.2 5.6 6.6 1 2.1 21-2.5 23H325z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.5 157s-3.3-3.3-3.7.6c-.5 4.5 3.6 6.3 4.4 4.9.8-1.4-.7-5.5-.7-5.5zm23.3.3s3.3-3.3 3.7.6c.5 4.5-3.6 6.3-4.4 4.9-.7-1.5.7-5.5.7-5.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.8 173.3c-7.4 0-11.6-4.8-11.6-19.3 0-7.5 3.8-12 12.1-12s11.8 4.6 11.8 12c0 15.6-4.6 19.3-12.3 19.3z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-9.903 341.987 159.527)",
    className: "st6",
    cx: 342,
    cy: 159.5,
    rx: 1.7,
    ry: 1.4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-86.269 326.803 159.505) scale(1.00002)",
    className: "st6",
    cx: 326.8,
    cy: 159.5,
    rx: 1.4,
    ry: 1.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.4 151.4c-.1 0-.2 0-.3-.1-1.2-.9-2.9-.6-3-.6-.2 0-.4-.1-.4-.3s.1-.4.3-.4c.1 0 2.1-.4 3.6.7.2.1.2.4.1.5-.1.2-.2.2-.3.2zm-14.1.1c-.1 0-.2-.1-.2-.1-.1-.2-.1-.4.1-.5 1.4-1.1 3.4-.8 3.5-.8.2 0 .3.2.3.4s-.2.3-.4.3c0 0-1.8-.3-2.9.7h-.4z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 338.7,
    cy: 155.6,
    rx: 0.9,
    ry: 1.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 328.9,
    cy: 155.6,
    rx: 0.9,
    ry: 1.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.5 143.6s7.9 2.9 19.2 2.1c0 0 2.4 3 2.1 13.6 0 0 6.6-19.1-12.7-19.1s-10.6 18.6-10.6 18.6-1.5-11.6 2-15.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.3 160.5l-.6-.6 1.5-1.5c-1.4-2-1.4-6.6-1.4-6.8h.8s0 5 1.4 6.6l.3.3-2 2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M329.4 163s7.3.3 10.9-.7c0 0 .6 5.3-5 5.6-5.9.2-5.9-4.9-5.9-4.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.5 183c1.4-.3 1.2 3.4 0 2.3-1.3-1.1-1.4-2.1 0-2.3zm-16.8 17.6c-.2 1.4-3.6.1-2.2-.8 1.5-.8 2.5-.6 2.2.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.8 208.1s-2.2 5.7-2.1 8.8c.1 3.2 1.2 2.8 1.2 2.8s-1.7.7-2 2.5 4.3 3.2 4.6 3.2c.3 0 3.6-1.2 3.6-1.2l.7-10.4-2.9-1.8-3.1-3.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.6 207.4s4 2.5 5.6 4 .7 13.3 0 13.9c-.7.6-5.8 1.7-6.8 1.1-1-.6.4-4.1.4-4.1s2.6-.6 2.2.4 0 1.8 0 1.8l1.1-.4s-.5-2.6 0-4.6c.5-1.9-3.6-4-4.1-7.5-.6-3.6 1.6-4.6 1.6-4.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M289 201.7c-1.3-5.5 4.2-7.5 11.9-6.6 8.9 1.1 27.1 3.4 31.1 13 0 0 1.3 3.8-2.1 5.6-9.3 5.2-38.5-1.6-40.9-12z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M316.8 198s-10.6-4.4-15.9-4.8c-5.2-.5 7.3 4.1 15.9 4.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396.1 102.7c-.8.9-2.1 4.5-2.1 4.5-.6 3-.9 4.6-1.9 6s-.5 3.8-.5 3.8-4 2.1-7.4-.5c0 0 .4-2.4 0-3.1-.7-1.4-2.9-2.1-3.7-4.8-.8-2.7-3.1-5.8-3.1-5.8s.7-1.4 1.9-.6c1.2.9 2 3.1 2.6 3.3.1 0 .3.1.4.1.5.1 1 0 1.3-.3 0 0 .1 0 .1-.1 1.1-1.3 1.4-5 1.3-6.7-.1-2.3 0-5.6 1.4-5 1.4.5.1 1.8 1.2 7l.5.1c.1.4 1.1-3.1 1.3-6.4.2-2.3 1.6-1.4 2-.7.3.7-.2 3-.3 4.6-.1 1.1-.2 2.2-.2 2.9l.6.3c2.2-3.9 1.5-5.5 2.8-5.6s.8 3.2.1 4.5c-.3.5-.6 1.7-.8 2.8 2.3-2.7 2-4 3.1-3.9 1.2 0 .2 2.7-.6 3.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.2 108.8c-.8-2.1-3.6-3.1-3.9-3.2.5.1 1 0 1.3-.3 2.8 1.1 2.6 3.5 2.6 3.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M338 392.8s-1.5-3.1-.2-4.5c1.4-1.3 3 1.2 5.3.6s2.9-2.2 3.5 0c.6 2.3-.1 9.4-8.6 3.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.8 392.6s-6.3 2.2-9.5 0l.8 2.7s6.8.7 7.8-1l.9-1.7zm-.1 3.4s-5.8-.8-8.5.6v1.3s7.5-1.8 9.9 0l-1.4-1.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.9 400.8s1.1-2.7 4.6-2.9c3.5-.2 5.9 1.7 5.9 1.7s-5.6-2.3-10.5 1.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M486 363c-11 14.7-26.1 17.6-26.1 17.6-4.4-3.5-4.5-7.6-4.5-7.6s-4.2-3.8-4.8-5.6c-.6-1.8 3.6-7.2 6.1-6.7 1.7.4 2.7 1.8 3.2 2.6-2.1-4.7-.4-6.3 2.5-5.9 3.1.4.2 1.1 2.4 3.6l.5.5c.4.3.9.5 1.4.6s1 .1 1.6.1c.3 0 .6 0 .9-.1.6-.1 1.1-.2 1.7-.4.9-.3 1.9-.7 2.8-1.2 3.8-2.1 5.4-2.8 8.3-2.1 2.9.7 2.9 2.9 2.9 2.9l1.1 1.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486 363c-11 14.7-26.1 17.6-26.1 17.6 7.7-3.3 14.7-7.6 19.5-12.9 4.9-5.4 6.6-4.7 6.6-4.7zm-20.6-1.5c.4.3.9.5 1.4.6-2.9.6-3.1 3.2-3.1 3.2l-1.2-.4c.2-3.2 2.7-3.4 2.9-3.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.3 365.6H466c-.5-1.8.1-2.9.8-3.6.5.1 1 .1 1.6.1-1.6 1.6-1.1 3.5-1.1 3.5zm3.2-.7l-1.3.2c-.5-1.3-.4-2.3 0-3 .6-.1 1.1-.2 1.7-.4-1 1.5-.4 3.2-.4 3.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M346.9 227.9s2.9 15.4-2.9 21.5-2 1.1-.2-6.8c1.7-7.9.4-16.2 3.1-14.7zm26.6-6.8s9.1 3 13.8 11.4c.1 0-6.3-13.7-13.8-11.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5 106.8c1.2 0 4.7 1.4 4.7 1.4 2.6 1.6 4 2.5 5.7 2.6 1.7.2 2.4 3.1 2.4 3.1s6.7 1.5 7.1-2.8c0 0-3.8-5.3-4-6-.5-1.4.4-3.6-1.1-6s-2.2-6.2-2.2-6.2-1.5-.5-1.7 1 .9 3.5.7 4.2c-.1.1-.1.2-.2.4-.3.4-.7.7-1.1.7h-.1c-1.7 0-4.6-2.4-5.8-3.5-1.7-1.6-4.1-3.7-4.7-2.3-.6 1.4 1.3 1.3 4.4 5.6l-.3.4c.2.3-3-1.3-5.6-3.3-1.8-1.4-2.2.3-1.8 1 .3.7 2.3 1.9 3.6 2.9.9.7 1.7 1.4 2.3 1.8l-.2.7c-4.4-1-5.1-2.6-6-1.7s1.8 2.8 3.2 3.1c.6.1 1.6.7 2.6 1.3-3.5-.1-4.4-1.2-5-.3-.7.8 1.9 1.8 3.1 1.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.7 103.5c-1.1-2 .1-4.7.2-5.1-.3.4-.7.7-1.1.7-1 2.9.9 4.4.9 4.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.3 106.8c-1.2 0-4.7 1.4-4.7 1.4-2.6 1.6-4 2.5-5.7 2.6-1.7.2-2.4 3.1-2.4 3.1s-6.7 1.5-7.1-2.8c0 0 3.8-5.3 4-6 .5-1.4-.4-3.6 1.1-6s2.2-6.2 2.2-6.2 1.5-.5 1.7 1-.9 3.5-.7 4.2c.1.1.1.2.2.4.3.4.7.7 1.1.7h.1c1.7 0 4.6-2.4 5.8-3.5 1.7-1.6 4.1-3.7 4.7-2.3.6 1.4-1.3 1.3-4.4 5.6l.3.4c-.2.3 3-1.3 5.6-3.3 1.8-1.4 2.2.3 1.8 1-.3.7-2.3 1.9-3.6 2.9-.9.7-1.7 1.4-2.3 1.8l.2.7c4.4-1 5.1-2.6 6-1.7s-1.8 2.8-3.2 3.1c-.6.1-1.6.7-2.6 1.3 3.5-.1 4.4-1.2 5-.3.7.8-1.9 1.8-3.1 1.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324.1 103.5c1.1-2-.1-4.7-.2-5.1.3.4.7.7 1.1.7 1 2.9-.9 4.4-.9 4.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M276.2 310.6l-12.9-80-25.9 2.9-25.9-2.9-12.9 80-6.2 77.6s2 6.4 14.9 2c0 0 9.6-72 11.1-73.5 1.5-1.6 16.7-48.6 16.7-48.6h4.8s15.2 47 16.7 48.6 11.1 73.5 11.1 73.5c12.9 4.4 14.9-2 14.9-2l-6.4-77.6zm-46.9-157.4c1.6 1.6 9.7 4.5 13.9 0l2.9 2.8s-3.3 7.7-9 8c-5.8.3-9.9-6.9-9.9-6.9l2.1-3.9zm22.8-.9c9.6-4.1 40.7-15.2 40.7-15.2s20.9-26.2 25.2-30.1c0 0 4.6.8 6 6.6 0 0-13.5 28.8-20.8 37.1-7.3 8.2-44.4 26.1-44.4 26.1l-6.7-24.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M218.4 151.7c2.9-1.8 17.2 7.8 17.2 7.8s18.7-9.9 23.1-8c0 0 4 5.3 5.5 18.9 1.6 13.6 1.7 69.5 1.7 69.5s-12.6 4.4-29.6 4.4c-19.4 0-29.8-5.6-29.8-5.6s-3.4-77.4 11.9-87z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.1 150.2s2.1 6.5 0 9c0 0 2.1 4.5 6 4.7 4.5.2 6-4.7 6-4.7s-2.4-6.3 0-8.5l-12-.5z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.9 143.8s-4.4-8.4-3.5-17.3c.9-9 14.4-11 23.5-6.6 0 0-2.7-2.6-1.6-3.4 1.1-.7 2.9 4 2.9 4s2.9-.9 3.3 0c.4.9-2.9 1.4-2.9 1.4s5.9 3.3.4 20.6l-22.1 1.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.2 138.5s-3.2-3.2-3.6.5c-.5 4.4 3.5 6.2 4.3 4.8.8-1.4-.7-5.3-.7-5.3zm22.8.3s3.2-3.2 3.6.5c.5 4.4-3.5 6.2-4.3 4.8-.8-1.4.7-5.3.7-5.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.3 154.4c-7.2 0-11.3-4.7-11.3-18.8 0-7.3 3.7-11.7 11.8-11.7s11.5 4.5 11.5 11.7c-.1 15.2-4.6 18.8-12 18.8z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-9.893 243.198 140.899)",
    className: "st6",
    cx: 243.2,
    cy: 140.9,
    rx: 1.7,
    ry: 1.3
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.06503 -.9979 .9979 .06503 72.943 359.662)",
    className: "st6",
    cx: 228.4,
    cy: 140.9,
    rx: 1.3,
    ry: 1.7
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.6 133.3c-.1 0-.2 0-.3-.1-1-1-2.7-1-2.8-1-.2 0-.4-.1-.4-.3s.1-.4.3-.4c.1 0 2.1-.1 3.3 1.2.1.1.1.4 0 .5 0 .1-.1.1-.1.1zm-13.6 0c-.1 0-.2 0-.2-.1-.1-.1-.1-.4 0-.5 1.2-1.3 3.2-1.2 3.3-1.2.2 0 .4.2.3.4 0 .2-.2.4-.4.3 0 0-1.8 0-2.8 1 0 .1-.1.1-.2.1z"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 240,
    cy: 137.1,
    rx: 0.9,
    ry: 1.6
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 230.4,
    cy: 137.1,
    rx: 0.9,
    ry: 1.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M231.3 146.7s6.4.8 9.6-.8c0 0-1.8 4.3-5.3 3.9-3.5-.3-4.3-3.1-4.3-3.1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.5 140.4s-.2-7.8-3.3-13.9c0 0-5.4 2.5-6.6 1.9-1.2-.6 1.1-1.9 1.1-1.9s-8.9 2.9-9.4 2.3 2.9-2.3 2.9-2.3l-5.5 1.9s-1.7 7.1-1 12c0 0-2.4-4.1-2.7-6.9-.3-2.8 1-10.9 9.3-11.5s13 1.3 15.1 5.1c2.1 3.8 1.9 8.5.1 13.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.5 144.4c-.7 0-1.4-.2-1.6-.2l.2-.7c.8.2 1.9.3 2.2 0 .1-.1.1-.4-.1-.7-1-2.2-1.3-7.8-1.3-8.1h.8c0 .1.2 5.7 1.2 7.8.3.6.3 1.1 0 1.5-.3.3-.8.4-1.4.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M244.5 155.2s13 40.5 14.3 73.4c0 0 4.7 1.3 10-5.9s2.1-64.4-8-73.9c0 0-4.6-1-16.3 6.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M246.6 162.3s2.3-5.4 1.3-9.1-4.7 0-4.7 0 1.5 6 3.4 9.1zm-26.2-10c-9.6-4.1-40.7-15.2-40.7-15.2s-21-26.9-25.2-30.8c0 0-5.3 3-5.6 9.2 0 0 13.2 27 20.5 35.3 7.3 8.2 44.4 26.1 44.4 26.1l6.6-24.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M228 155.2s-13 40.5-14.3 73.4c0 0-4.7 1.3-10-5.9s-2.1-64.4 8-73.9c0 0 4.6-1 16.3 6.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M225.9 162.3s-2.3-5.4-1.3-9.1c1-3.7 4.7 0 4.7 0s-1.5 6-3.4 9.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M293.9 409.1H268c-1.8-10.3 1.1-20.6 1.1-20.6l11.8-2c1.1 6.5 2.4 9.1 4.2 10.4 1.3 1 2.9 1.3 4.8 1.9 2.2.8 3.4 2.2 4 3.7 1.2 3 0 6.6 0 6.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M294 402.5c-6.4.8-20.4 2.2-19.6-1.5.7-3.1 6.6-3.9 10.7-4.1 1.3 1 2.9 1.3 4.8 1.9 2.3.7 3.5 2.2 4.1 3.7z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M207.2 409.1h-25.9s-.8-2.4-.4-5c.3-2.1 1.4-4.3 4.4-5.3 2.2-.8 4-1.1 5.4-2.4 1.5-1.4 2.7-4.1 3.6-9.9l11.8 2c.1 0 2.9 10.3 1.1 20.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M180.9 404.1c.3-2.1 1.4-4.3 4.4-5.3 2.2-.8 4-1.1 5.4-2.4 3.3 1 7.9 2.9 9.3 5.7 1.9 3.8-13.2 3.2-19.1 2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M393.1 407.2c0 1.1-.1 1.9-.1 1.9h-31.5v-1.9c.4-8.2 3-15.4 3-15.4l7.9-3.4c.7 4.1 2.4 6.6 4.6 8.3.6.5 1.2.8 1.8 1.2.3.2.6.3.9.4.7.3 1.3.5 2 .7 2.8.8 5.6 1 7.5 1.3 3.4.7 3.9 4.5 3.9 6.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M393.1 407.2c0 1.1-.1 1.9-.1 1.9h-31.5v-1.9h31.6zm-14.3-9.3l-4.4 1.4-.9-1.6 3.5-1c.6.5 1.2.9 1.8 1.2zm2.9 1.2l-2.9 2-1.8-.7 2.7-2c.6.3 1.3.5 2 .7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M272.9 407.2c-.1 1.1-.4 1.9-.4 1.9h-21c-.3-.6-.5-1.2-.6-1.9-2.1-10 11.9-22.3 11.9-22.3l4.4 5.9s-.5 9.4 3.2 11.4c2.4 1.2 2.7 3.4 2.5 5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M251 407.2h21.9c-.1 1.1-.4 1.9-.4 1.9h-21c-.1-.7-.3-1.3-.5-1.9zm18.6-5.7s-8.8-2-12.9.6v-1.5s7.5-3.6 12.9.9z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M267.8 399.2s-5.6-2.6-11.1 0l.6-1.5c.1 0 6.6-2.4 10.5 1.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M383.6 318.1c0 8.4-7.5 77.1-7.5 77.1-7.5.7-13.5-.8-13.5-.8-2.1-34.8-2.3-64.8-2.3-64.8l-35.9-26.9-.1-.1s-.1.6-.4 1.7c-1.8 7.9-9.3 40.9-12.4 48.5-3.6 8.6-42.5 44.8-42.5 44.8-7.2-1-13.4-6.2-13.4-6.2 14-23.2 33.1-46.5 33.1-46.5 1.5-8.4 2.6-27 3.2-40.9v-.6c.4-9.4.6-16.5.6-16.5l-6.6-13.5 41.8-15.3 9.4 12s2.1 2 5.5 5.2c.2.1.3.3.5.4 12.6 11.9 40.5 38.6 40.5 42.4z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M292 304.2v-.6c8.8-4.8 7.3-12.4 7.3-12.5l.5-.1c.1 0 1.7 8.2-7.8 13.2zm31.9-6.8c.3 1.7.5 3.5.6 5.4l-.1-.1s-.1.6-.4 1.7c-.4-13.1-5.8-20.8-5.8-20.9l.5-.3c.1.1 3.5 5 5.1 13.5 6.4-5.6.1-17.2.1-17.3l.5-.3c0 .2 6.6 12.5-.5 18.3zm19.3-21.6c-.3.1-.6.2-.9.2-3.1 0-8.2-4.3-8.5-4.5l.4-.4c1.7 1.4 6.4 4.8 8.6 4.3l.4.4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289 201.7s12.7-2 19.1 2c6.4 4.1 14.7 14.6 14.7 14.6s-9.9 1.3-11 8c0 .1-7.3-17.1-22.8-24.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.9 208.3c-5.4 2.9-14.4 13.8-14.8 20.5-.4 6.5 4.4 12.6 7.7 17.7 10.2 16 20.9 30.1 25.5 48.8 0 .1 23.3 9.4 50.6-23.5 0 0-15.4-20.8-20.8-38.5-2.2-7.2-4.4-14.8-8.6-21.2-4.6-7-12.5-11.1-20.6-10.4-6.8.5-13.7 3.7-19 6.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.7 201.6s3.4 5.9 1.8 9.1c0 0 11.8 4.1 11.8-2.5 0 0-2.2-4.9-1.4-8.1l-12.2 1.5zm26.2 40.2s-6.6 1.9-8.2 4.2-3.1 7.5-3.1 7.5h11.3l2.1-3.9 2.5-5.2-4.6-2.6z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M283 195s4.6-1.9 1.6-15.8c-2-9.2-4.8-10.5-6.7-10.6 0 0-2.2-3.4-10-1.8-5.3 1.1-9.6 4.4-11.5 10.4-2 6.3 2 19.7 7.1 21L283 195z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M284.1 185.7s2.9-4 4-.1c1.3 4.6-2.7 7.2-3.8 5.9-1-1.4-.2-5.8-.2-5.8zm-24.3 4.2s-4-2.9-3.8 1.2c.3 4.8 4.9 6 5.4 4.3.6-1.5-1.6-5.5-1.6-5.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.1 204.6c7.7-1.3 11.2-7 8.7-22.1-1.3-7.8-6-11.9-14.7-10.5-8.6 1.4-11.5 6.8-10.2 14.6 2.8 16.2 8.2 19.3 16.2 18z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.0092 -1 1 .0092 70.245 454.102)",
    className: "st6",
    cx: 264.3,
    cy: 191.6,
    rx: 1.4,
    ry: 1.8
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.094 280.103 188.886)",
    className: "st6",
    cx: 280.1,
    cy: 188.9,
    rx: 1.8,
    ry: 1.4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.6 183.2c-.1 0-.2 0-.2-.1-.2-.1-.2-.4-.1-.5 1.1-1.6 3.2-1.9 3.3-1.9.2 0 .4.1.4.3s-.1.4-.3.4c0 0-1.9.3-2.8 1.6-.1.1-.2.2-.3.2zm14.5-2.4c-.1 0-.2 0-.2-.1-1.2-.9-3.1-.6-3.1-.6-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.5.1 0 2.2-.4 3.8.7.2.1.2.4.1.5-.2.2-.3.3-.4.3z"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-9.369 266.907 186.997)",
    className: "st7",
    cx: 266.9,
    cy: 187,
    rx: 1,
    ry: 1.8
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-9.369 277.308 185.295)",
    className: "st7",
    cx: 277.3,
    cy: 185.3,
    rx: 1,
    ry: 1.8
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M279.2 194.1s-6.7 1.8-10.4 1.1c0 0 2.6 3.2 6.2 2.3 3.7-.9 4.2-3.4 4.2-3.4z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.5 175.5s-8.7 6.3-19.6 6.8l.3 9.7s-10.2-18.8 10-22.1c20.1-3.3 14.3 17.6 14.3 17.6s-.7-9-5-12z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.4 191.5l-.1-.8s1.2-.1 1.5-.8c.1-.3-.4-1.2-.8-2.1-.6-1.2-1.4-2.6-1.7-4.2l.8-.2c.3 1.5 1 2.9 1.6 4 .6 1.2 1.1 2.1.8 2.8-.4 1.2-2.1 1.3-2.1 1.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M284.2 175.5c-14.6-6.4-28.4 6.8-28.4 6.8s-1.6-10.7 1.2-13.2c.7-.7 1.5-1.2 2.3-1.7 6.5-4.1 15.1-4 19-2.6.8.3 1.4.6 1.8 1 2.3 2.5 4.1 9.7 4.1 9.7z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.4 173.1s-12.3-2.4-23.7 5.2c0 0-.7-6.9.6-10.9 6.5-4.1 15.1-4 19-2.6 2.3 2.7 4.1 8.3 4.1 8.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M257 181.1s1.9-8.3 4.6-10.6c4.4-3.9 16.6-5.2 23.1-2.9s0 9.4 0 9.4-10.3-7.4-27.7 4.1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276 236.1s5 7.8 13.6 12.4c0 0 10.7-9.3 24.6-8.5 0 0-11.5 20.7-21.4 23-5.2 1.2-24-11.2-24-11.2s3.7-13.2 7.2-15.7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.5 222c4.6-7.5 15.2 3.6 18.8 11.5 3.6 7.9 6.2 9.6 6.2 9.6s-10.6 4.4-10.5 12.4c0-.1-24.6-17.2-14.5-33.5z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.5 245s6.5-6.3 27.7-14.6l-2.7-8.6c2.4-3.2 6.9-3.2 6.9-3.2s10.9 15.4 9 19.9c-1.2 2.9-23.9 5.9-40.9 6.5z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.8 232.5s.2-.9 1-2 .6-3.1.9-3.7c.3-.6 2-3.2 3.1-3.7s2.6-1.3 2.9.1c.3 1.4-2 1-3 3 0 0 2.3-.7 4-.3 1.8.4 2.3 2.1.1 2-1.8 0-4 1.2-4 1.2s2.3.3 1.9 1.4c-.7 1.5-3.5.6-6.9 2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M155.8 261.4c1.9 4.9 9.7 13.2 9.7 13.2s19-11.4 27.7-6.6c8.8 4.8 15.7 7.7 21.4 5.6s-18.7-46.4-18.7-46.4l-31.6-12.1s-.7 8-4.3 9.4-7.5 14.6-7.2 17.1c.3 2.6 3 19.8 3 19.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.3 274.9s-8.1 16-25 36.4c0 0-1.7 24.3-46.2 62.6l-4.7-3.7s26.5-41.5 31.8-54.2-2.9-24.4 21.4-56.5l22.7 15.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M165.4 246.6c-7 13.4-9.4 30.6-9.4 30.6l-3.2 8.1s11.3 6.1 24.4 8.3l5.2-13.9-17-33.1z",
    fill: "#0a3d56"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202 273.6s3.5 17.6 2.9 44c0 0 13.7 20.2 2.4 77.7h-5.9s-4.8-49-8.5-62.2c-3.7-13.3-17.4-17.3-18.1-57.7l27.2-1.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M205.5 292.5s-11.1 2-30.8 1.1l-.3-2.2-.1-.6-2-14.3s-1.9-2.3-3.8-6.1c-.2-.4-.5-.9-.7-1.4-2.6-5.6-5-13.8-2.4-22.3l4.1.2h.6l13.9.6h.6l4.6.2h.7l3 .1s15 13.5 12.3 38.5l.2 3.5v.6l.1 2.1z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M170.1 246.8c-.4 1.1-3 9.6-1.7 23.5-.2-.4-.5-.9-.7-1.4-1-12.7 1.3-20.6 1.8-22.2.1-.2.1-.3.1-.3l.5.2c.1.1.1.2 0 .2zm35.3 43.6c-3.9 1-10.6 1.3-17 1.3-5.7 0-11.1-.2-14-.4l-.1-.6c5 .2 18.1.8 26.6-.2l-.5-8.9c.1-10.4-3-19.3-6.1-25.5-7.7-1.4-9.8-7.1-10.3-8.7-.1-.3-.1-.4-.1-.4l.5-.1s0 .2.1.5c.5 1.7 2.6 6.6 9.4 8-2.1-4-4-6.8-4.8-7.8-.2-.3-.4-.5-.4-.5l.4-.4s.3.3.7.9c2.6 3.5 11.3 16.7 11 33.9l.5 8.9c1.5-.2 2.8-.4 3.9-.7l.2.7z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M177 186.4c-4.4-2.4-36.3 10.1-36.3 10.1s-4.7 8.4-1.8 11.7 13.4 1.8 16.5 0c3.2-1.8 11.6-3.2 11.6-3.2l10-18.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M205.1 159.9s6.6 2.5 9 10.1-4.8 26.8-2.3 35.6 2.1 25.5-5.7 29-23.7-2.8-27.1-12.4c-3.4-9.6-1.9-46.1 4.6-58.5 6.7-12.4 20-6.2 21.5-3.8z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M197.6 192.6c1.7 1.9 6.2-1.5 6.2-1.5s-.1 16.5-4.9 17.8c-4.8 1.3-17.1-13-16.6-16.9.5-3.9 11.4-3.6 15.3.6z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.1 188.4s4.9 4.1 13.3 6.1c8.5 2 13.1-2 17.4 3.4 6.5 8.2-4.1 23.3-9.6 31.1-2.1 2.9-6.5 11-7.3 18.8 0 0-14.7 4.3-27.4-1.3l-.9-18c-.1.1-8.1-24.2 14.5-40.1z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M194.3 206s6.7-16 8.7-17c1.9-1 6.9 1.4 7.9 3.6s0 7 0 7-5.4-6.1-16.6 6.4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M226.4 273.6c-3.1 6.3-10.5 8-10.5 8s-.6-.9-1.5-2.4c-.1-.2-.2-.3-.3-.5-5.9-9.6-23.9-40.1-23.6-56.1.4-19 12.8-29.4 12.8-29.4 6.3 1.5 8.3 3.2 8.3 3.2s2.1 10.8.2 23.8c-1.9 13-5.5 16.4-3.7 17.4s0 2.9 0 2.9 10.4 14.6 12.4 19.1c1.3 3 3.4 8 4.8 11.1l.3.6c.4 1.4.8 2.3.8 2.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208.3 196.4s-7.5 5.5-3.1 14l20.7 21.5c-11.4 12.1-12.5 17.1-20.7 22.7l3.1 4.8s28.8-22.1 28.9-27.5c-.1-2.3-17.7-30.2-28.9-35.5z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.7 254.6s-4 .4-6.4 1.1c-2.5.6-5.8 1.2-5.9 1.8-.1.5 5.5 0 5.5 0s-4.6 1.9-4.7 2.6 5.8-.5 5.8-.5-3.7 2.3-3.5 2.9 4.8-.9 4.8-.9-.9 2.2-1.7 3.2c0 0 .9.5 2.7-1.5s4.7-1.4 7-3.1c2.2-1.9-1.5-5.8-3.6-5.6z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M183.5 191.1s-5.7 3.7-9.3 12.6c-3.6 8.9-14.9 25.6-17.6 29.9-2.7 4.3-.8 27.8-.8 27.8s-3.3-14.2-4.8-19.8 4.8-19.3 5.7-20 5.8.6 4.8-5 12-29.6 15.4-30.2c.1 0 5.6 1 6.6 4.7zm-17.6 1.2l-.3.6c-1.3 1.9-3.7 3.3-3.7 3.3s-4.3 6.1-4.4 6.8c0 .6-7.5 6-10.9 5.9-.5 0-.8-.1-1.1-.4-2-1.9 6.7-17.5 8.6-20.9.1-.2.2-.4.3-.5 0-.1.1-.1.1-.1s-1.5-5.7 4.9-4.6c5.3.9 6.4 5.1 6.9 7.9.1.7 0 1.3-.4 2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.6 198.2c4.4-5.8 19.9-17 28-20.3l2 3.8s-15.7 13.8-19.4 19.7-8.3 8.4-12.6 6.4c-4.5-1.9 1-8.4 2-9.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M164.4 191.1l-.8 1-.4.5-1.4 1.6s-3.5 4.2-3.3 5.9c.1 1.2-6.6 6.6-11.8 8.9-2.1.9-4 1.3-5.1.7-3.8-2.2-2.9-8.7-.8-13.1 1.9-3.9 10.1-8.8 12.2-10.1.3-.2.4-.3.5-.3l.8-3.1s2.9-1.7 5.1-.7c0 0-5 .2-4.2 2.2.9 1.8 7.8 6.4 9.2 6.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.5 175.1c-5 2.1-4.3 6.6-8.9 6.6-2.9 0-3.2-3.3-3.2-3.3 1.3-2.8 2.1-7.5 2.3-9.8s.9-1.4.9-1.4v-.6c-.1-1.5-.3-2.6.7-2 1.1.7 1.5 5 1.5 5 .9-6.3-.5-7.2.6-6.7 1.5.8 1.5 6.3 1.5 6.5 1.2-3.7.9-5.7 1.7-4.9s-.4 7.5-.9 10c-.1.6-.2.9-.2.9 4-1.8 4-.3 4-.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.7 174.6c-.1.6-.2.9-.2.9s-1.8-.2-3.2 1.8c0 0 .4-2.6 3.4-2.7zm-4.8-2.8c0-.5.3-3.6-.3-4.5v-.6c1.1.2.4 4.4.3 5.1z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M177 198.2s3.4-9.2 4.5-11.3 6.7-1.7 11-.9 5.1 6.5 5.1 6.5-13-6-20.6 5.7z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.9 180.1s-4.1 7.5-4 15.9c0 0-6.6 4.5-9-1.1 0 0 2.5-7.4 1.3-17.3-.8-6.8 11.7 2.5 11.7 2.5z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.9 169.7s-1.2-4.3-3.4-1.3c-2.5 3.5 0 6.9 1.4 6.1 1.3-.8 2-4.8 2-4.8zm19.2 11.1s4.3-1.2 2.8 2.2c-1.7 4-5.9 3.5-5.9 2 0-1.6 3.1-4.2 3.1-4.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.7 188.5c-6.1-3.4-7.3-9.4-.6-21.4 3.5-6.2 8.8-8.2 15.6-4.4 6.9 3.9 7.6 9.3 4.1 15.5-7.2 12.9-12.8 13.8-19.1 10.3z"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-70.506 200.885 180.798)",
    className: "st6",
    cx: 200.9,
    cy: 180.8,
    rx: 1.3,
    ry: 1.6
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-56.886 188.282 173.705)",
    className: "st6",
    cx: 188.3,
    cy: 173.7,
    rx: 1.3,
    ry: 1.6
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M203.3 173.6c-.2 0-.3-.1-.3-.3-.3-1.4-1.9-2.2-1.9-2.2-.2-.1-.2-.3-.1-.5s.3-.2.5-.1c.1 0 1.8 1 2.2 2.6 0 .2-.1.4-.4.5z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.9 167.6c-.1 0-.1 0-.2-.1 0 0-1.5-.9-2.8-.5-.2.1-.4 0-.4-.2-.1-.2 0-.4.2-.4 1.6-.5 3.3.5 3.4.5.2.1.2.3.1.5-.1.1-.2.2-.3.2z"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-60.613 199.974 176.115)",
    className: "st7",
    cx: 200,
    cy: 176.1,
    rx: 1.6,
    ry: 0.9
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-60.613 191.386 171.477)",
    className: "st7",
    cx: 191.4,
    cy: 171.5,
    rx: 1.6,
    ry: 0.9
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.2 179.7s3.5 2.7 6.1 2.8c0 0-2.7 2.2-4.6.8-2-1.5-1.5-3.6-1.5-3.6zm9.7-4.7s1.6-1.6 2.3-1c.7.5.3 2.5.3 2.5h1.4l-1.2-.5s.4-2-.3-2.4c-1-.6-2.5 1.4-2.5 1.4zm-6.1-3.2s.5-2.2-.3-2.5-2.3 1-2.3 1l-.8-1.2 1 .8s1.5-1.4 2.2-.9c1.2.6.2 2.8.2 2.8z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M204.4 165.3s-2.2-3.1-5.2-.6c-3 2.4-9.9 6.3-13.2 5-3.4-1.3 7.4-15.6 16.7-11.4 9.3 4.2 8.5 17.9 4.6 22.2s-2 .3-2 .3.3-6.2 1.6-10.2c1.1-4.2-2.5-5.3-2.5-5.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194 178.3c-.2 0-.3 0-.5-.1l.2-.7c.6.2.9-.1 1.1-.4.2-.4.2-.8 0-1-.1-.1-.3-.1-.5 0l-.4-.7c.8-.4 1.2-.1 1.4.1.4.4.5 1.3.1 1.9-.3.6-.8.9-1.4.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M238.9 231.1c-.4 5.4-13.7 22.9-15.9 23.5-.6.2-1.2.5-1.7.9-.2.2-.5.3-.7.5-1.3 1-2.2 2.2-2.2 2.2-3.9-.3-14.8-5.3-11.3-6.4.2-.1.4-.2.7-.4.1-.1.3-.2.5-.4 4.1-3.5 12.2-17.5 12.2-18.6 0-1.2 1.4-1.4 1.4-1.4s-7.6-11.1-12-12.5c-4.4-1.3-6.6-6.7-6.6-6.7-4.3-18.4 8.3-15.5 8.3-15.5 9.3 5.7 27.7 29.4 27.3 34.8z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M221.3 255.5c-.2.2-.5.3-.7.5-6-.4-11-3.3-12.8-4.6.1-.1.3-.2.5-.4 1.9 1.3 7 4.2 13 4.5zm-55.4-63.2l-.3.6c-.9 0-1.7-.1-2.4-.3-3.9-.8-7-3-9-4.9-.5-.4-.9-.9-1.2-1.3.3-.2.4-.3.5-.3.3.3.6.7 1 1 2 1.9 5.1 4.2 9.1 4.9.7.2 1.5.3 2.3.3zm59.6 79.1c-1.8 3.1-5.2 6.8-11.1 7.8-.1-.2-.2-.3-.3-.5 6.1-.9 9.4-4.9 11.2-7.9 0 .2.1.4.2.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124.4 372.5s-1.4 1.4-2.8 3.9.1 4.8-6.8 10.6c0 0-14.1-8.2-20.5-18.9 0 0 .1-3 3.2-3.7 1.7-.4 6.2 1.8 10.6 2.6.6.1 1.2.2 1.9.3.8.1 1.5.1 2.2 0s1.3-.2 1.9-.5c1.5-.6 2.7-1.8 3.3-3.9 0 0 3.7 2.1 1.2 5.7 0-.1 4.4-2 5.8 3.9z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.8 387s-14.1-8.2-20.5-18.9c0 0 2.4-.5 4.3 3 2 3.5 17.3 11.5 16.2 15.9zm0-16.7c-1.1 1.8-1.1-1.5-2.6-3.1.7-.1 1.3-.2 1.9-.5.7.8 1.6 2.2.7 3.6zm-4.4.1c-1.2 1.1-1.6-1.8-2.3-3.4.6.1 1.2.2 1.9.3.6.9 1.3 2.2.4 3.1z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.1 409.1h-19.9s-.8-2.8 0-5.8c.4-1.3 2.4-2.6 4.3-4.3l1.5-1.5c.4-.4.7-.9 1-1.5.4-.6.7-1.3.8-2.1.3-1.5.2-3.3-.7-5.4 0 0 6.8-1.4 9.2 2.3 0 0 .2-1.7 2.4-.6 0 0-.3 3.4.1 6.3.5 2.8 3.2 3.7 1.3 12.6z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.9 397.1c-.2.2-.4.3-.7.3-.2 0-.4-.1-.6-.2-1-.8-3.3-2.1-6.6-1.2.4-.6.7-1.3.8-2.1 1.3-.5 3.8-.8 6.9 1.9.5.3.6.9.2 1.3zm-1.6 3.3l-.1.2c-.3.4-.8.5-1.2.3-1.4-.8-4.4-2.3-7.4-1.9l1.5-1.5c1.5-.3 4.3-.5 7 1.7.3.3.4.8.2 1.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsvg);
export default __webpack_public_path__ + "static/media/friendsvg.339a6185cfff118b8da1f5af2a023e66.svg";
export { ForwardRef as ReactComponent };